import React from "react";
import SVGraphics from "../../../assets/SVGraphics";
import utils from "../../../utils/utils";
import BodySeparator from "../../../components/customComp/BodySeparator";
import PatientList from "./PatientList";
const PatientsBody = (props) => {
  const { patientsData, addTab } = props;
  return (
    <div className={"flex-col flex w-full h-full max-h-[85%] mt-10 overflow-hidden"}>
      <div className="listLabels text-white font-Inter opacity-50 text-[13px] font-normal flex">
        <div className="ml-[30px] w-patientId">Patient ID</div>
        <div className="w-fullName">Full Name</div>
        <div className="w-age">Age</div>
        <div className="w-status">Status</div>
        <div className="w-findings">Findings</div>
        <div className="w-previousCases">Previous Cases</div>
        <div className="w-aquisitionDate">Aquisition Date</div>
      </div>
      {/* <BodySeparator text={`Findings (${patientCount})`} marginBottom="22px"/> */}

      <PatientList patients={patientsData} addTab={addTab}/>
    </div>
  );
};

export default PatientsBody;
